import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth/auth.css';

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-wrapper">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 24px',
          borderRadius: '50%',
          background: 'rgba(239, 68, 68, 0.1)',
          border: '3px solid rgba(239, 68, 68, 0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ fontSize: '48px', color: '#ef4444' }}>✗</div>
        </div>

        <h1 style={{ color: '#ef4444', marginBottom: '16px' }}>Payment Failed</h1>
        
        <div style={{
          padding: '16px 20px',
          marginBottom: '24px',
          borderRadius: '8px',
          background: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)'
        }}>
          <p style={{ color: '#ef4444', fontSize: '16px', fontWeight: '600', margin: '0 0 8px 0' }}>
            Payment failed. Please try again.
          </p>
          <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>
            Your payment could not be processed. Please check your payment details and try again, or contact support if the issue persists.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button 
            className="button"
            onClick={() => navigate('/payment')}
            style={{ width: '100%' }}
          >
            Try Again
          </button>
          
          <button 
            className="button"
            onClick={() => navigate('/signup')}
            style={{ 
              width: '100%',
              background: 'transparent',
              border: '1px solid #334155',
              color: '#9ca3af'
            }}
          >
            Select Different Plan
          </button>

          <button 
            className="button"
            onClick={() => window.location.href = 'mailto:support@asuma.io'}
            style={{ 
              width: '100%',
              background: 'transparent',
              border: '1px solid #334155',
              color: '#9ca3af'
            }}
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
